import { routes } from 'commons/constants/routes'
import { ClientUserPermissionsHelper } from 'commons/utils/clientUserPermissionsHelper'
import { DateTime } from 'ui/components/DateTime'
import { Link } from 'ui/components/Link'
import { TableColumn } from 'ui/components/Table'
import { ClientPortalUsersActivityReportItem } from '~bank-reports/types/ClientPortalUsersActivityReport'

export const columns: TableColumn<ClientPortalUsersActivityReportItem>[] = [
  {
    title: 'Relationship',
    align: 'left',
    sortable: true,
    key: 'companyName',
    render: ({ id, companyName }) => (
      <Link to={routes.bank.relationships.details} params={{ id: id.toString() }}>
        {companyName}
      </Link>
    )
  },
  {
    title: 'User Email',
    align: 'left',
    sortable: true,
    key: 'userEmail'
  },
  {
    title: 'User Last Login',
    align: 'right',
    key: 'userLastLoginAt',
    render: ({ userLastLoginAt }) => <DateTime date={userLastLoginAt} withTime />
  },
  {
    title: 'User Created At',
    align: 'right',
    sortable: true,
    key: 'userCreatedAt',
    render: ({ userCreatedAt }) => <DateTime date={userCreatedAt} withTime />
  },
  {
    title: 'Company Business Type',
    align: 'right',
    sortable: true,
    key: 'companyBusinessType'
  },
  {
    title: 'Company Customer Status',
    align: 'right',
    sortable: true,
    key: 'companyCustomerStatus'
  },
  {
    title: 'Permissions',
    align: 'center',
    sortable: false,
    render: ({ permissions }) => ClientUserPermissionsHelper.getAccessibleRolesLabel(permissions)
  }
]
